import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { withRouter, RouteComponentProps } from 'react-router';
import { connect } from "react-redux";
import { fullName } from "utils/helpers";
import UserAvatar from "react-user-avatar";
import { ICartProduct, getCartSize } from "reducers/cart";
import cn from "classnames";
import { USER_ROLES } from "enums/userRoles";

import logo from "img/OLogo.png";
import { IRootState } from "reducers";
import { Actions as userActions } from "reducers/user";

import AddPhoto from "img/prof.png";

interface IProps {
  username: string;
  logout: () => void;
  cartSize: number;
  photoProfile: any;
  userAvatarName: string;
  userRole: number;
}

const Header: React.FC<IProps & RouteComponentProps> = ({
  username,
  logout,
  cartSize,
  photoProfile,
  userAvatarName,
  userRole,
}) => {
  const [isShowMenu, setIsShowMenu] = useState(false);

  const handleShowMenu = () => {
    setIsShowMenu(!isShowMenu);
  };

  const menuPanel = document.getElementById('menu');
  const burgerMenuMobile = document.getElementById('burger');

  useEffect(() => {
    document.addEventListener('click', outsideEvtListener);
    return () => {
      document.removeEventListener('click', outsideEvtListener);
    }
  });

  const outsideEvtListener = (e: any) =>  {
      if (menuPanel && !menuPanel.contains(e.target) && burgerMenuMobile && !burgerMenuMobile.contains(e.target)) {
          setIsShowMenu(false);
          return;
      }
  }

  return (
    <nav className="navbar navbar-expand-xl navbar-light bg-white fixed-top navstyle">
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={handleShowMenu}
        id="burger"
      >
        <svg
          className="d-none d-md-inline meta_burger"
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.071 17.8975H15.9282C15.3949 17.8975 14.9639 18.3295 14.9639 18.8617C14.9639 19.394 15.3949 19.826 15.9282 19.826H39.071C39.6043 19.826 40.0353 19.394 40.0353 18.8617C40.0353 18.3295 39.6043 17.8975 39.071 17.8975Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
          <path
            d="M39.071 26.5361H15.9282C15.3949 26.5361 14.9639 26.9681 14.9639 27.5004C14.9639 28.0327 15.3949 28.4647 15.9282 28.4647H39.071C39.6043 28.4647 40.0353 28.0327 40.0353 27.5004C40.0353 26.9681 39.6043 26.5361 39.071 26.5361Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
          <path
            d="M39.071 35.1738H15.9282C15.3949 35.1738 14.9639 35.6058 14.9639 36.1381C14.9639 36.6704 15.3949 37.1024 15.9282 37.1024H39.071C39.6043 37.1024 40.0353 36.6704 40.0353 36.1381C40.0353 35.6058 39.6043 35.1738 39.071 35.1738Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
        </svg>
        <svg
          className="d-md-none meta_burger"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.8777 9.12305H8.12261C7.85175 9.12305 7.63281 9.34248 7.63281 9.61284C7.63281 9.88321 7.85175 10.1026 8.12261 10.1026H19.8777C20.1486 10.1026 20.3675 9.88321 20.3675 9.61284C20.3675 9.34248 20.1486 9.12305 19.8777 9.12305Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
          <path
            d="M19.8777 13.5107H8.12261C7.85175 13.5107 7.63281 13.7302 7.63281 14.0005C7.63281 14.2709 7.85175 14.4903 8.12261 14.4903H19.8777C20.1486 14.4903 20.3675 14.2709 20.3675 14.0005C20.3675 13.7302 20.1486 13.5107 19.8777 13.5107Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
          <path
            d="M19.8777 17.8984H8.12261C7.85175 17.8984 7.63281 18.1179 7.63281 18.3882C7.63281 18.6586 7.85175 18.878 8.12261 18.878H19.8777C20.1486 18.878 20.3675 18.6586 20.3675 18.3882C20.3675 18.1179 20.1486 17.8984 19.8777 17.8984Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
        </svg>

        <svg
          width="22"
          id="closeburger"
          height="21"
          viewBox="0 0 22 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"

        >
          <path
            d="M19.0004 1.68219L2.63595 18.0467C2.25889 18.4237 2.25957 19.034 2.63595 19.4104C3.01234 19.7868 3.62259 19.7874 3.99966 19.4104L20.3641 3.04589C20.7412 2.66883 20.7405 2.05857 20.3641 1.68219C19.9878 1.30581 19.3775 1.30512 19.0004 1.68219Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
          <path
            d="M19.4096 18.0922L3.04513 1.72775C2.66807 1.35069 2.05781 1.35137 1.68143 1.72775C1.30505 2.10413 1.30436 2.71439 1.68143 3.09146L18.0459 19.4559C18.423 19.833 19.0332 19.8323 19.4096 19.4559C19.786 19.0795 19.7867 18.4693 19.4096 18.0922Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
          />
        </svg>
      </button>

      <a href="#" className="navbar-brand pl-3">
        <img src={logo} className="logo" />
      </a>
      <div
        className={cn(
          "navbar navstyle justify-content-xl-end w-100 py-0 collapse navbar-collapse",
          { show: isShowMenu }
        )}
        id="navbarSupportedContent"
      >
        <ul className="nav navbar-nav" id="menu">
          <NavLink
            to="/home/dashboard"
            className="nav-item"
            activeClassName="active"
            onClick={() => setIsShowMenu(false)}
          >
            <li className="d-lg-block">
              <span className="nav-link">Рабочий стол</span>
            </li>
          </NavLink>
          { userRole === USER_ROLES.CAR_AGENT
            ? <NavLink to="/home/vin" className="nav-item" activeClassName="active" onClick={() => setIsShowMenu(false)}>
              <li className="d-lg-block">
                <span className="nav-link">Проверка VIN</span>
              </li>
            </NavLink>
            : null
          }
          <NavLink
            to="/home/catalog"
            className="nav-item"
            activeClassName="active"
            onClick={() => setIsShowMenu(false)}
          >
            <li className="d-lg-block">
              <span className="nav-link">Каталог</span>
            </li>
          </NavLink>
          <NavLink
            to="/home/news"
            className="nav-item"
            activeClassName="active"
            onClick={() => setIsShowMenu(false)}
          >
            <li className="d-lg-block">
              <span className="nav-link">Новости</span>
            </li>
          </NavLink>
          <NavLink
            to="/home/analytics"
            className="nav-item"
            activeClassName="active"
            onClick={() => setIsShowMenu(false)}
          >
            <li className="d-lg-block">
              <span className="nav-link">Аналитика</span>
            </li>
          </NavLink>
          {/* <NavLink
            to="/intro"
            className="nav-item"
            activeClassName="active"
            onClick={() => setIsShowMenu(false)}
          >
            <li className="d-lg-block">
              <span className="nav-link">Слайдер</span>
            </li>
          </NavLink> */}
        </ul>
      </div>
      <div className="enter d-flex">
        <div className="border_one d-none d-lg-block">
          <svg
            width="1"
            height="70"
            viewBox="0 0 1 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.5"
              y1="-2.18557e-08"
              x2="0.500003"
              y2="70"
              stroke="url(#paint0_linear)"
            />
            <defs>
              <linearGradient
                id="paint0_linear"
                x1="1.88462e-06"
                y1="-15.8846"
                x2="5.24723e-06"
                y2="89.3846"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.00552486" stopColor="white" />
                <stop offset="0.491713" stopColor="#E5E5E5" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <Link to={"/home/cart"}>
          <div className="cart_mini">
            <svg
              className="cart-mini__large-screen"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.8557 5.22393C24.7126 5.01883 24.4823 4.89205 24.2322 4.88137L8.72447 4.21291C8.27952 4.19344 7.9077 4.53696 7.88868 4.97983C7.86977 5.42254 8.21272 5.7966 8.65554 5.81562L23.1134 6.43887L20.2707 15.3083H7.62024L5.33476 2.86404C5.28452 2.59129 5.09727 2.36376 4.83902 2.26244L1.09578 0.791878C0.683232 0.630359 0.217699 0.832999 0.0556768 1.24505C-0.106065 1.65732 0.096518 2.12313 0.508846 2.28515L3.83718 3.59269L6.163 16.2554C6.2331 16.6361 6.56486 16.9126 6.95207 16.9126H7.33788L6.45689 19.3597C6.38315 19.5647 6.41353 19.7923 6.53902 19.9704C6.66434 20.1485 6.86815 20.2545 7.08573 20.2545H7.70366C7.32076 20.6806 7.08573 21.2417 7.08573 21.8588C7.08573 23.1857 8.16545 24.2651 9.49211 24.2651C10.8188 24.2651 11.8985 23.1857 11.8985 21.8588C11.8985 21.2418 11.6635 20.6806 11.2806 20.2545H16.5271C16.1441 20.6806 15.9091 21.2417 15.9091 21.8588C15.9091 23.1857 16.9885 24.2651 18.3155 24.2651C19.6425 24.2651 20.7219 23.1857 20.7219 21.8588C20.7219 21.2418 20.4869 20.6806 20.1041 20.2545H20.8556C21.2248 20.2545 21.524 19.9552 21.524 19.5861C21.524 19.2168 21.2248 18.9176 20.8556 18.9176H8.03683L8.75865 16.9123H20.8555C21.2044 16.9123 21.513 16.687 21.6193 16.3551L24.9615 5.92735C25.0382 5.68935 24.9988 5.42914 24.8557 5.22393ZM9.49217 22.9285C8.90232 22.9285 8.42263 22.4489 8.42263 21.859C8.42263 21.2692 8.90232 20.7895 9.49217 20.7895C10.082 20.7895 10.5616 21.2692 10.5616 21.859C10.5616 22.4489 10.082 22.9285 9.49217 22.9285ZM18.3155 22.9285C17.7256 22.9285 17.246 22.4489 17.246 21.859C17.246 21.2692 17.7256 20.7895 18.3155 20.7895C18.9053 20.7895 19.385 21.2692 19.385 21.859C19.385 22.4489 18.9053 22.9285 18.3155 22.9285Z"
                fill="black"
              />
            </svg>
            <svg
              className="cart-mini__small-screen"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5705 3.46383C16.4751 3.33256 16.3215 3.25147 16.1548 3.24463L5.81634 2.81679C5.51967 2.80431 5.2718 3.02421 5.25914 3.3076C5.24654 3.59093 5.47514 3.83035 5.77034 3.84251L15.4089 4.24143L13.5138 9.91784H5.08014L3.55654 1.95349C3.523 1.77896 3.3982 1.63336 3.226 1.56847L0.730538 0.627346C0.455471 0.523986 0.145138 0.65365 0.0371378 0.91733C-0.0707288 1.1812 0.0643373 1.47931 0.339204 1.58306L2.55814 2.41986L4.10867 10.524C4.1554 10.7676 4.3766 10.9446 4.63474 10.9446H4.89194L4.3046 12.5107C4.2554 12.6419 4.27567 12.7876 4.35934 12.9016C4.44287 13.0156 4.5788 13.0834 4.7238 13.0834H5.1358C4.88054 13.3561 4.7238 13.7152 4.7238 14.1102C4.7238 14.9594 5.4436 15.6502 6.32807 15.6502C7.21254 15.6502 7.93234 14.9594 7.93234 14.1102C7.93234 13.7153 7.77567 13.3561 7.5204 13.0834H11.0181C10.7627 13.3561 10.6061 13.7152 10.6061 14.1102C10.6061 14.9594 11.3257 15.6502 12.2103 15.6502C13.095 15.6502 13.8146 14.9594 13.8146 14.1102C13.8146 13.7153 13.6579 13.3561 13.4027 13.0834H13.9037C14.1499 13.0834 14.3493 12.8919 14.3493 12.6556C14.3493 12.4193 14.1499 12.2278 13.9037 12.2278H5.35787L5.83914 10.9444H13.9037C14.1363 10.9444 14.342 10.8002 14.4129 10.5878L16.641 3.914C16.6921 3.76168 16.6659 3.59515 16.5705 3.46383ZM6.32814 14.7948C5.93487 14.7948 5.61507 14.4878 5.61507 14.1103C5.61507 13.7328 5.93487 13.4258 6.32814 13.4258C6.72134 13.4258 7.04107 13.7328 7.04107 14.1103C7.04107 14.4878 6.72134 14.7948 6.32814 14.7948ZM12.2103 14.7948C11.8171 14.7948 11.4973 14.4878 11.4973 14.1103C11.4973 13.7328 11.8171 13.4258 12.2103 13.4258C12.6035 13.4258 12.9233 13.7328 12.9233 14.1103C12.9233 14.4878 12.6035 14.7948 12.2103 14.7948Z"
                fill="black"
              />
            </svg>

            {cartSize > 0 && <div className="label_cart">{cartSize}</div>}
          </div>
        </Link>

        <div className="border_one">
          <svg
            width="1"
            height="70"
            viewBox="0 0 1 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.5"
              y1="-2.18557e-08"
              x2="0.500003"
              y2="70"
              stroke="url(#paint0_linear)"
            />
            <defs>
              <linearGradient
                id="paint0_linear"
                x1="1.88462e-06"
                y1="-15.8846"
                x2="5.24723e-06"
                y2="89.3846"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.00552486" stopColor="white" />
                <stop offset="0.491713" stopColor="#E5E5E5" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <Link to={"/home/profile"} className="d-flex align-items-center">
          <div className="enter__img">
            <div className="header-profile-img"><UserAvatar  name={userAvatarName} src={photoProfile} /></div>
          </div>
          <span className="navbar-text d-none d-xl-block">{username}</span>
        </Link>
        <a
          onClick={logout}
          className="enter-exit d-xl-flex align-items-center pl-4 pr-3 cursor-pointer"
        >
          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0)">
              <path
                d="M2.86543 21.2014H11.4618C11.9072 21.2014 12.2669 21.5612 12.2669 22.0065C12.2669 22.4519 11.9072 22.8117 11.4618 22.8117H2.86543C1.36846 22.8117 0.15 21.5932 0.15 20.0962V2.90356C0.15 1.40659 1.36846 0.188086 2.86543 0.188086H11.4618C11.9071 0.188086 12.2669 0.547938 12.2669 0.993305C12.2669 1.43865 11.9072 1.79843 11.4618 1.79843H2.86543C2.25539 1.79843 1.7603 2.29347 1.7603 2.90356V20.0963C1.7603 20.7063 2.25534 21.2014 2.86543 21.2014Z"
                fill="#212121"
                stroke="white"
                strokeWidth="0.3"
              />
              <path
                d="M16.8027 5.19555L16.8028 5.19571L22.61 10.9265C22.7642 11.079 22.8501 11.2843 22.8501 11.4998C22.8501 11.7154 22.7633 11.9216 22.61 12.0733L16.8028 17.8041L16.8027 17.8042C16.6467 17.9586 16.4426 18.0359 16.2377 18.0359C16.03 18.0359 15.8224 17.9556 15.6643 17.7959C15.3527 17.4792 15.3555 16.9697 15.6724 16.6576L15.6726 16.6575L19.8227 12.5618L20.0828 12.3051H19.7173H8.59649C8.15115 12.3051 7.79136 11.9452 7.79136 11.4999C7.79136 11.0545 8.15114 10.6948 8.59649 10.6948H19.7173H20.0828L19.8227 10.438L15.6726 6.34233L15.6724 6.34221C15.3552 6.02982 15.352 5.5203 15.6644 5.2039C15.977 4.88722 16.4875 4.8836 16.8027 5.19555Z"
                fill="#212121"
                stroke="white"
                strokeWidth="0.3"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="23"
                  height="23"
                  fill="white"
                  transform="matrix(1 0 0 -1 0 23)"
                />
              </clipPath>
            </defs>
          </svg>
        </a>
      </div>
    </nav>
  );
};

const mapStateToProps = ({ user, cart: { products } }: IRootState) => ({
  username: fullName(user.first_name, user.second_name, user.patronymic),
  cartSize: getCartSize(products) ,
  photoProfile: user.photo,
  userAvatarName: `${user.second_name} ${user.first_name}`,
  userRole: user.role_id!,
});

const actions = {
  logout: userActions.logout
};

export default withRouter(connect(mapStateToProps, actions)(Header));
